import API from "service";

export async function getCarehomesService({ signal }) {
  const url = "secure/dashboard/carehomes/get-all";
  const { data } = await API.get(url, { signal });
  return data;
}

export async function getSimplifiedCarehomesService() {
  const url = "/secure/dashboard/care-home/users/get-all";
  const { data } = await API.get(url);
  return data;
}

export async function registerCarehomeService(request) {
  const { data } = await API.post("secure/onboarding/care-home", request);
  return data;
}

export async function updateCarehomeSubscriptionsService({
  userId,
  subscriptionId,
  thrivers,
}) {
  const url = `/open/onboarding/care-home/${userId}/subscription/${subscriptionId}?newLimitThrives=${thrivers}`;
  const { data } = await API.put(url);
  return data;
}
